import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText';
import { CustomEase } from 'gsap/all';
import ScrambleTextPlugin from 'gsap/ScrambleTextPlugin';

import { Flip } from 'gsap/Flip';

export default defineNuxtPlugin(() => {
  gsap.registerPlugin(
    ScrollTrigger,
    SplitText,
    Flip,
    CustomEase,
    ScrambleTextPlugin
  );

  const ButterEase = CustomEase.create('butter', 'M0,0 C0.7,0 0.05,1 1,1');
  const SmoothEase = CustomEase.create('smooth', '0.5, 0, 0, 1');
  const SmoothEaseNano = CustomEase.create('smoothNano', '0.25, 0, 0, 1');
  const SmoothEaseNanoOut = CustomEase.create('smoothNanoOut', '0, 0, 0, 0.75');
  const natural = CustomEase.create('natural', '0, 0, 0, 1');
  const slowStart = CustomEase.create('slowStart', '0.73, 0, 0, 1');
  const fra = CustomEase.create('fra', '0.408, 0.770, 0.185, 0.998');
  const fastStart = CustomEase.create('fastStart', '0.17, 0.67, 0.1, 0.99');

  // gsap.config({ nullTargetWarn: false });

  if (import.meta.server) {
    // gsap.registerPlugin(Draggable);
  }

  return {
    provide: {
      gsap,
      ScrollTrigger,
      SplitText,
      Flip,
      ScrambleTextPlugin,
    },
  };
});
